<template>
  <div class="login-page">
    <el-card class="login-card">
      <h2 style="margin-bottom: 16px; text-align: center;">系统登录</h2>
      <el-form :model="form" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="onSubmit">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return
        this.loading = true
        // 前端本地校验
        setTimeout(() => {
          if (this.form.username === 'xczn' && this.form.password === 'xczn123456') {
            localStorage.setItem('auth_token', 'static-ok')
            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect || '/statistics'
            this.$router.replace(redirect)
          } else {
            this.$message.error('账号或密码错误')
          }
          this.loading = false
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f5f7fa;
}
.login-card {
  width: 360px;
}
</style>



